module.exports = __webpack_public_path__ + "static/media/reachedTournamentTop10_20_25.d78aacee.png";